import { render } from "./executions-trades-block.vue?vue&type=template&id=ee81194c&scoped=true"
import script from "./executions-trades-block.vue?vue&type=script&lang=js"
export * from "./executions-trades-block.vue?vue&type=script&lang=js"

import "./executions-trades-block.vue?vue&type=style&index=0&id=ee81194c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee81194c"]])

export default __exports__